export default __webpack_public_path__ + "static/media/Sova_artwork.e3f0f692.png";